/**
 * CÓMO SE NOMBRA A UNA PERSONA EN UN BOTÓN QUE ES SUYO.
 *
 * En un club hay tres «Beto», y por eso las listas muestran el nombre de pila
 * debajo del apodo. Los BOTONES de esas listas —aprobar, rechazar, arrastrar,
 * subir, bajar, quitar, cambiar de lugar— se llamaban con el apodo solo, así
 * que para quien escucha la pantalla eran seis botones idénticos por cada
 * homónimo, sin forma de saber cuál es cuál.
 *
 * VA ACÁ Y NO EN CADA COMPONENTE porque son siete lugares que tienen que
 * sonar igual: con una copia en cada uno, al primero que cambie lo siguen
 * seis que no.
 *
 * NO TOCA EL TEXTO VISIBLE. «Label in Name» pide que el nombre accesible
 * CONTENGA lo que se ve, para que quien maneja la aplicación por voz pueda
 * decir «Quitar» y que le haga caso. Esto se usa solo en `aria-label`.
 *
 * La coma y no un paréntesis: un lector de pantalla hace una pausa en la coma
 * y lee cada tipo de paréntesis a su manera. «Beto Vargas, María de los
 * Ángeles» suena como se dice.
 */
export function nombreParaLeer(persona: {
  displayName: string;
  /** Puede faltar: en la vista pública el nombre legal no viaja. */
  firstName?: string | undefined;
}): string {
  const pila = persona.firstName;
  // Ausente y vacío son lo mismo acá: no hay nada que agregar.
  return pila === undefined || pila === '' ? persona.displayName : `${persona.displayName}, ${pila}`;
}
